import { HomeDataPropsType } from 'src/views/Service/Home'
import HomeDeviceInfoCard from 'src/components/atomic/organisms/views/Home/HomeDeviceInfoCard'
import HomeEmergencyContact from 'src/components/atomic/organisms/views/Home/HomeEmergencyContact'
import HomeLockScreenMsg from 'src/components/atomic/organisms/views/Home/HomeLockScreenMsg'
import HomeViewUserGuide from 'src/components/atomic/organisms/views/Home/HomeViewUserGuide'
import React, { forwardRef } from 'react'
import styled from 'styled-components'

const HomeTemplateWrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

const HomeTemplate = forwardRef(
  (props: { data: HomeDataPropsType }, msgInputRef?: React.Ref<HTMLTextAreaElement>) => {
    return (
      <HomeTemplateWrap>
        <HomeDeviceInfoCard data={props.data} />
        <HomeEmergencyContact data={props.data} />
        <HomeLockScreenMsg data={props.data} ref={msgInputRef} />
        <HomeViewUserGuide />
      </HomeTemplateWrap>
    )
  },
)
export default HomeTemplate
